import { IDashboardApiState } from '../types/dashboard.types';

export const DASHBORD_INTIAL_STATE: IDashboardApiState = {
    data: [],
    patientVisitMTD: [],
    loading: 'idle',
    error: null,
};
